import type { ClassValue } from 'clsx'
import type { CSSProperties } from 'react'

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/** stagger offset for a `[data-reveal]` element inside a revealed group */
export const revealDelay = (seconds: number): CSSProperties => {
    return { '--d': `${seconds}s` } as CSSProperties
}